import makeStyles from '@material-ui/core/styles/makeStyles';

export const userCardHorizontalPdLg = '40px';
export const userCardHorizontalPdMd = '30px';
export const userCardHorizontalPdSm = '20px';

export const useStyles = makeStyles((theme) => ({
  rootCard: {
    position: 'relative',
    // background: 'unset',
    background: '#F3F4F6',
    // padding: `0 ${userCardHorizontalPdLg} 50px`,
    padding: '32px 22px 32px 32px',
    [theme.breakpoints.down('md')]: {
      padding: `13px ${userCardHorizontalPdMd}`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: `32px ${userCardHorizontalPdSm}`,
      background: '#FAFAFA',
    },
  },
  askQuestionBody: {
    maxWidth: '100%',
  },
}));
